import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import styles from "./accessories-make.module.scss";

function MakeItem(props: any) {
  const { url, make } = props;
  return (
    <Link key={url} href={url}>

      <PAText>

        <div className={`${styles.subcategory} d-flex flex-row align-items-center justify-content-start`}>

          <div>
            <PAImage
              alt={make}
              src={createMakeImageSource({ make })}
              width={50}
              height={50}
              unoptimized
            />
          </div>
          <span className="p-l-20">
            {make}
          </span>
        </div>
      </PAText>
    </Link>
  );
}

export default MakeItem;
